/**
 * @file ThemeProvider.tsx
 * @description
 * -----------------------------------------------------
 * Contexto de tema (claro o oscuro) para la aplicación
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-11-04
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useSession } from "@/features/auth";
import { updateProfile } from "@/features/profile";
import { setUserTheme as setCookieTheme } from "@/features/theme/actions";
import { createContext, useCallback, useContext, useEffect } from "react";
import { Theme } from "../types";
const ThemeContext = createContext({
  theme: "light" as Theme,
  toggleTheme: () => {}
});
export function ThemeProviderInternal(t0) {
  const $ = _c(12);
  const {
    children,
    theme
  } = t0;
  const session = useSession();
  const applyTheme = _temp;
  let t1;
  let t2;
  if ($[0] !== theme) {
    t1 = () => {
      applyTheme(theme);
    };
    t2 = [applyTheme, theme];
    $[0] = theme;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== session || $[4] !== theme) {
    t3 = async () => {
      const newTheme = theme === "light" ? "dark" : "light";
      if (session.status === "authenticated") {
        const partialNewProfile = new FormData();
        partialNewProfile.append("theme", newTheme);
        const response = await updateProfile(partialNewProfile);
        await session.update({
          ...response.data,
          theme: newTheme
        });
      }
      applyTheme(newTheme);
    };
    $[3] = session;
    $[4] = theme;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const toggleTheme = t3;
  let t4;
  if ($[6] !== theme || $[7] !== toggleTheme) {
    t4 = {
      theme,
      toggleTheme
    };
    $[6] = theme;
    $[7] = toggleTheme;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== t4) {
    t5 = <ThemeContext.Provider value={t4}>{children}</ThemeContext.Provider>;
    $[9] = children;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(nextTheme) {
  document.documentElement.setAttribute("data-theme", nextTheme);
  setCookieTheme(nextTheme);
}
export function useThemeProvider() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeProvider must be used within a ThemeProviderInternal");
  }
  return context;
}